<template>
  <div class="order-1 order-lg-0">
    <Imagen
      :rbd="rbd"
      :imagen="imagenPrincipal"
      :alt="'imagen-principal'"
      :width="512"
      :height="384"
      imgClass="img-fluid"
    />
    <b-button
      :disabled="imagenes.length == 0"
      @click="abrirModal"
      v-b-modal.modal-carousel-ficha
      variant="outline"
      id="abrir-carousel-galeria"
      data-testid="abrir-carousel-galeria"
      class="btn btn-yellow w-100 mt-3 font-weight-bold mb-2 btn-secondary"
    >
      <FontAwesomeIcon icon="images" class="mr-2" />
      Ver galería</b-button
    >
    <b-modal
      ref="modal"
      size="lg"
      footer-class="d-none"
      hide-header
      centered
      body-class="p-0"
      button-size="lg"
    >
      <b-carousel
        id="carousel-ficha"
        style="text-shadow: 0px 0px 2px #000"
        controls
        no-animation
        indicators
      >
        <b-carousel-slide
          v-for="(img, index) in imagenes"
          :key="index + '-image-carrousel'"
        >
          <Imagen
            slot="img"
            :rbd="rbd"
            :imagen="img"
            :alt="'imagen-carrusel-' + index"
            imgClass="img-fluid"
            :width="800"
          />
        </b-carousel-slide>
      </b-carousel>
    </b-modal>
  </div>
</template>

<script>
import Imagen from "@/components/generales/Imagen";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faImages);
export default {
  components: {
    FontAwesomeIcon,
    Imagen
  },
  props: {
    imagenes: {
      type: Array,
      required: true
    },
    imagenPrincipal: {
      type: String,
      required: true
    },
    rbd: {
      type: Number,
      required: true
    }
  },
  methods: {
    abrirModal() {
      this.$refs.modal.show();
      this.$gtag.event("ver-galeria", {
        event_category: "galeria",
        event_label: "galeria",
        value: ""
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/GaleriaImagenes.vue